<template>
  <div class="card card-minimal-one">
    <div class="card-body" style="pointer-events:none" v-loading="loading">
        <label style="text-transform: none;color:#1c273c">Estimated Fund Investments</label>
        <h6 class="mb-0" style="font-size: 22px;margin-top:5px">{{total_value.int}}<small>{{total_value.dec}}</small>
        <small class="sm" v-bind:class='{ "bg-success": changedata.change>=0,"bg-danger":changedata.change<0 }'>{{changedata.change>=0? '+'+changedata.change+'%':changedata.change+'%'}}</small>
        </h6>
        <div class="btn-group" style="pointer-events:auto" >
            <button v-for="button in buttongroup" :key="button" v-bind:class="{ active: isclicked===button }" class="btn" @click='isclicked=button'>{{button}}</button>
        </div>
    </div><!-- card-body -->
    <div class="chart-wrapper" style="pointer-events:auto">
        <ChartFundValue v-if="isChartShow" ref="chart" :days="chartdata.days" :values="chartdata.values" :trends="chartdata.trends"/>
    </div><!-- chart-wrapper -->
  </div><!-- card -->
</template>
<script>
export default {
  name: 'fundvalue',
  components:{
    ChartFundValue : ()=>import('../charts/ChartFundValue.vue'),
  },
  props: {
    
  },
  watch:{
    isclicked:function(oldVal,newVal){
         return this.isclicked==='Day'? this.changedata.change = this.changedata.day
               :this.isclicked==='Month'? this.changedata.change = this.changedata.month
               :this.changedata.change = this.changedata.quarter
    }
  },
  data(){
    return{
        chartdata:{
            days:[],
            values:[],
            trends:[],
        },
        isChartShow:false,
        changedata:{
            change:'',
            day:'',
            month:'',
            quarter:'',
        },
        total_value:{
            int: '',
            dec: ''
        },
        isclicked:'Day',
        buttongroup:['Day','Month','Quarter'],
        smsfs:'',
        members:'',
        loading:true,
    }
  },
  created(){
        this.getFundvalue();
    
  },
  methods:{
        getFundvalue: function(){
            this.$api.funddashboard_api.fundBalance(this.$route.params.fund_code).then(response =>{
                //get the chartdata from response
                this.chartdata.days = response.data["days"];
                this.chartdata.values = response.data["market_value"];
                let trends = response.data["trend"];
                trends.unshift(0);
                this.chartdata.trends = trends;
                
                //calculate the total value and changes 
                this.getTotalValue();
                this.getChangeData();
                this.initValues();
                this.loading=false
            });

        },
        getLatest(){
            return this.chartdata.values[this.chartdata.values.length-1];
        },
        getTotalValue(){
            let formatter = new Intl.NumberFormat('en-AU', {
                style: 'currency',
                currency: 'AUD',
            });
            let format_value = formatter.format(this.getLatest());
            this.total_value.int = (format_value.split('.'))[0];
            this.total_value.dec = '.'+(format_value.split('.'))[1];
        },
        getChangeData(){
            let value_month_ago = this.chartdata.values[this.chartdata.values.length-30];
            let value_quarter_ago = this.chartdata.values[this.chartdata.values.length-91];
            this.changedata.day = this.chartdata.trends[this.chartdata.trends.length-1]
            this.changedata.month = parseFloat(100 * (this.getLatest() - value_month_ago) / value_month_ago).toFixed(2);
            this.changedata.quarter = parseFloat(100 * (this.getLatest() - value_quarter_ago) / value_quarter_ago).toFixed(2);
            this.changedata.change = this.day;
            
        },
        initValues(){
            this.changedata.change = this.changedata.day;
            this.isChartShow = true;
        }
  }
} 

    
    
  
</script>
<style scoped>
.btn-group{
    float:right;
    padding:2px;
    position: relative;
    display: inline-flex;
    vertical-align: middle;
    font-family: "Roboto", sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #031b4e;
    text-align: left;
    word-wrap: break-word;
    margin-top: 0;
    margin-left:30%;
    margin-right:30%;
    width:20px;
  
}
.btn{
    font-size: 8px;
    font-weight: 400;
    padding: 3px 8px;
    min-height: inherit;
    background-color: #fff;
    color: #7987a1;
    border: 1px solid #cdd4e0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    position: relative;
    flex: 1 1 auto;
}
.active{
    color: #1c273c;
    background-color: #e3e7ed;
    border-color: #cdd4e0;
    z-index: 1;
}

.sm{
    color: #fff;
    width: 42px;
    padding: 2px 3px;
    font-size: 9px;
    font-weight: 500;
    line-height: 1.1;
    margin-left: 5px;
    margin-bottom: 5px;
    letter-spacing: normal;
}
</style>